module.exports = __webpack_public_path__ + "media/images/og-2a8ca81a5515f36c941c4536983b53e4.png";